<template>
  <div class="cmp-distribution-suppliers-supplier_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddSupplierClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        class="h1"
        :id="'distribution-suppliers-supplier_list'"
        :headers="headers"
        :config="tableConfig"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
            @click="onSupplierClicked(item)"
          >
            <td v-bind="tdcon('supplier_name')">
              <span style="font-weight: bold">{{ item["supplier_name"] }}</span>
            </td>
            <td v-bind="tdcon('supply_order_type_name')">
              <span>{{ $t(item["supply_order_type_name_key"]) }}</span>
            </td>
            <td v-bind="tdcon('company_name')">
              <span>{{ item["company_name"] }}</span>
            </td>
            <td v-bind="tdcon('city')">
              <span>{{ item["city"] }}</span>
            </td>
            <td v-bind="tdcon('phone1')">
              <span>{{ item["phone1"] }}</span>
            </td>

            <td v-bind="tdcon('email1')">
              <span @click.stop="(e) => emailLink(item)">
                <img
                  v-if="item['email1'] && item['email1'] !== ''"
                  src="static/icons/email/email-grey.svg"
                  class="dt-icon v5 s2"
                  :alt="item['email1']"
                  :title="item['email1']"
                />
              </span>
            </td>
            <td v-if="item.show_delete>0" v-bind="tdcon('options')">
              <div class="option-buttons">
                <div class="dt-icon-container">
                  <img
                    src="static/icons/delete.svg"
                    @click.stop="(e) => onSupplierDelete(item)"
                    class="dt-icon v5 s2"
                    alt="Delete supplier"
                    title="Delete supplier"
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <Sidewindow
      :navConfig="defaultConfig"
      :value="supplierDetailsFlag"
      @closed="onCloseSupplierDetails"
    >
      <SupplierSidewindow />
    </Sidewindow>
    <ModalContainer :modalKey="'newSupplier'" :width="'small'">
      <NewSupplier @cancelled="onDialogCancelled" @added="onAdded" />
    </ModalContainer>
  </div>
</template>

<script>
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import InputField from "@plugins/text-field/input-field";
import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { DistributionStoreNamespace as storeNS } from "../../store";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import {
  getSupplierDetailsSelectable,
  distributionSupplierListLDTRoutes,
} from "../../router/routes";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { distributionSupplierActions } from "../../store/suppliers/actions";
import { distributionSupplierGetters } from "../../store/suppliers/getters";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { DTIconButton } from "../../../../plugins/button/button";
import { createTV, tv } from "../../../../models/text-value.model";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import NewSupplier from "./new-supplier.vue";
import SupplierSidewindow from "./suppliers-sidewindow.vue";
import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
import { sendMailHref } from "../../../../utility";
import { async } from "ramda-adjunct";
const LDTConfig = {
  entityName: "supplier",
  ldtRoutes: distributionSupplierListLDTRoutes,
  detailsSelectableFunction: getSupplierDetailsSelectable,
  primaryKey: "supplier_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.SupplierDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.SupplierDetails.FETCH.SINGLE,
};

export default {
  components: {
    ModalContainer,
    NTable,
    InputField,
    DTCheckbox,
    DTIconButton,
    NewSupplier,
    SupplierSidewindow,
  },
  mounted: async function () {},
  data: function () {
    return {
      defaultConfig: defaultConfig,
      getSupplierDetailsSelectable: getSupplierDetailsSelectable,
      selectedClickedSupplier: null,
    };
  },
  mixins: [
    createLDTHost(LDTConfig),
    createFetchListMixin(ActionTypes.SupplierList.FETCH.ALL, 100, {
      advancedSearchable: false,
      searchable: true,
      scrollable: false,
    }),
    createModalMixin("newSupplier"),
  ],

  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetterObject(storeNS, distributionSupplierGetters),

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      return this.supplierList?.suppliers || [];
    },

    headers: function () {
      return [
        createTableHeader("Supplier"),
        createTableHeader("Type"),
        createTableHeader("Company"),
        createTableHeader("City"),
        createTableHeader("Phone1"),
        createTableHeader("email1", {
          text: this.$t("email"),
          mw: 50,
          minw: 50,
        }),
        createTableHeader("options", { text: false, mw: 45 }),
      ];
    },
    supplierDetailsFlag: function () {
      return childOfOrEqualDetails(
        distributionSupplierListLDTRoutes,
        this.$route
      );
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionSupplierActions),
    emailLink(item) {
      sendMailHref({
        mails: [item["email1"]],
        body: "",
        subject: "",
      });
    },
    defaultBasicFilter() {
      return {
        searchString: undefined,
      };
    },
    onListScroll: function (value) {
      console.log("OOO",this.start,this.row_count)
       this.scrollSubject.next(this.start);
    },
    selectedRow: function (supplier) {
      return (
        this.selectedClickedSupplier &&
        this.selectedClickedSupplier["supplier_id"] == supplier["supplier_id"]
      );
    },
    refresh: function () {
      this.fetchList();
    },

    onAdded: function (supplier) {
      // const list = [...this.list, payload];
      // this[ActionTypes.SupplierList.SET.ALL](list);
      this.refresh();
      this.onDialogCancelled();
      this.$router.push({
        name: distributionSupplierListLDTRoutes.names.tab,
        params: {
          supplier_id: supplier.supplier_id,
          tab: "overview",
        },
      });
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddSupplierClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "new_supplier",
        },
      });
    },

    onSupplierDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Supplier",
        item.supplier_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.SupplierList.DELETE.SINGLE](item);
      }
      // ConfirmationService.create({
      //   subject: "Do you really want to delete this Supplier?",
      //   model: true,
      //   width: 500,
      //   results: [
      //     createConfirmResult({
      //       value: "Cancel",
      //     }),
      //     createConfirmResult({
      //       value: "ok",
      //       text: "Ok",
      //       classes: ["v1"],
      //     }),
      //   ],
      //   completed: (res) => {
      //     switch (res) {
      //       case "ok":
      //         this[ActionTypes.SupplierList.DELETE.SINGLE](item);
      //         break;
      //       default: {
      //       }
      //     }
      //   },
      // });
    },

    // onAccountMailClick: function (item) {
    //   location.href = `mailto: ${item.email1}`;
    // },

    // Start Sidewindow
    onSupplierClicked: function (supplier) {
      console.log("supplier ", supplier);
      this.$router.push({
        name: distributionSupplierListLDTRoutes.names.tab,
        params: {
          supplier_id: supplier.supplier_id,
          tab: "overview",
        },
      });
    },
    onCloseSupplierDetails: function () {
      this.selectedClickedSupplier = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: distributionSupplierListLDTRoutes.names.list,
        });
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-distribution-suppliers-supplier_list {
  .dt-page--body {
    --offset: 160px;
  }
  .dt-page--top-bar {
    .search {
      .dt-checkbox-control {
        .dt-checkbox-label {
          color: var(--text-accent);
          font-weight: 500;
        }
      }
    }
  }
  .account-list-footer {
    border-top: 1px solid var(--sprt-5);
    padding: 0 10px;

    .status-list {
      .status {
        margin-top: 15px;
        max-width: 110px;
      }
    }
  }
}

.status {
  flex: 1;
  display: flex;
  align-items: center;
  max-width: 150px;
  .circle-status {
    margin-right: 10px;
  }
  .status-name {
    flex: 1;
  }
}
</style>
